import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './HeaderBar.module.css'
import { Button, Image, Input, message, Popconfirm, Tooltip } from 'antd'
import Icon, { PlusOutlined, SearchOutlined } from '@ant-design/icons'
import questionIcon from '../../../assert/question.svg'
import noticeIcon from './notice.svg'
import collectIcon from './collect.svg'
import settingIcon from './setting.svg'
import { closeHomePage, openLogin } from '../../../store/modalsSlice'
import { setCurrentMenuKey } from '../HomePageSlice'
import { clearAllCookies } from '../../../util/handleObject'
import { setShowPlayerModalStatus, setVideoId } from '../../PlayerModal/PlayerModalSlice'
export default function HeaderBar(props) {
  //   const count = useSelector(selectCount);
  const dispatch = useDispatch()
  const [messageApi, contextHolder] = message.useMessage()

  // const incrementValue = Number(incrementAmount) || 0;

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
      // console.log('组件即将卸载');
    }
  }, []) // 空数组意味着这个 effect 只会在组件挂载时执行一次

  return (
    <div
      className={styles.background}
      //  onKeyDown={keyPress}
    >
      {contextHolder}
      <div className={styles.leftTitle}>AI素养学院</div>
      <div className={styles.rightContainer}>
        <Tooltip placement="top" title={'点我看视频，快速了解所有功能！'}>
          <div
            className={styles.iconContainer}
            onClick={(e) => {
              dispatch(setShowPlayerModalStatus(true))
              dispatch(setVideoId('f0e881c98ebe71f0bf8d1777b3df0102'))
              e.stopPropagation()
              e.preventDefault()
            }}
          >
            <img src={questionIcon} style={{ width: '24px', height: '24px' }} />
          </div>
        </Tooltip>
        <div className={styles.iconContainer}>
          <img src={noticeIcon} style={{ width: '24px', height: '24px' }} />
        </div>
        <div
          className={styles.iconContainer}
          onClick={(e) => {
            dispatch(setCurrentMenuKey('1'))
          }}
        >
          <img src={collectIcon} style={{ width: '24px', height: '24px' }} />
        </div>
        <Popconfirm
          placement="bottom"
          title={''}
          description={'是否退出登录'}
          okText="是"
          cancelText="否"
          onConfirm={(e) => {
            sessionStorage.clear()
            clearAllCookies()
            dispatch(closeHomePage())
            dispatch(openLogin())
          }}
        >
          <div className={styles.iconContainer}>
            <img src={settingIcon} style={{ width: '24px', height: '24px' }} />
          </div>
        </Popconfirm>
        <Button
          icon={<PlusOutlined />}
          style={{ borderRadius: '16px', height: '56px', width: '162px' }}
          // type='primary'
          htmlType="submit"
          color="primary"
          variant="outlined"
          block
          onClick={props.createBot}
        >
          基础智能体
        </Button>
        {/* <Button
          icon={<PlusOutlined />}
          style={{
            borderRadius: '16px',
            height: '56px',
            width: '162px',
            marginLeft: '20px',
          }}
          type="primary"
          htmlType="submit"
          block
          onClick={(e) => {
            window.open('https://agent.ygbh.run')
          }}
        >
          高级智能体
        </Button> */}
      </div>
    </div>
  )
}
